import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Col, Row, Stack } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import {
  onChangeToNumber,
  validateEmail,
} from "../../../../utils/helperFunction";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { setFormDataNearMiss } from "../../../../redux/slice/QuickReportSlice";

const NearMissPageOne = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { nearMissFormData } = useSelector((state) => state.QUICKREPORT);
  // main state for the form data
  const today = new Date().toISOString().split("T")[0];
  const getCurrentTime = () => {
    const now = new Date();
    let hours = now.getHours();
    let minutes = now.getMinutes();

    // Add leading zero for single digit hours and minutes
    if (hours < 10) hours = `0${hours}`;
    if (minutes < 10) minutes = `0${minutes}`;

    return `${hours}:${minutes}`;
  };

  const currentTime = getCurrentTime();
  const [formData, setFormData] = useState(nearMissFormData);

  //onchange function to manipulate the state of the form data on change of input field
  //@@parm is event

  const onChange = (event) => {
    const { name, value } = event.target;
    if (name === "date") {
      const selectedDate = new Date(value);
      const maxDate = new Date(today);
      selectedDate.setHours(0, 0, 0, 0);
      maxDate.setHours(0, 0, 0, 0);
      if (selectedDate > maxDate) {
        toast.error("Toady is maximum date");
      }
      setFormData((prev) => ({
        ...prev,
        date: {
          value: selectedDate > maxDate ? today : value,
          warning: !value ? true : false,
        },
      }));
    } else if (name === "time") {
      // Convert selected time and current time into minutes from midnight
      const getTimeInMinutes = (time) => {
        const [hours, minutes] = time.split(":").map(Number);
        return hours * 60 + minutes; // Convert time to minutes from midnight
      };
      const selectedTimeInMinutes = getTimeInMinutes(value);
      const currentTimeInMinutes = getTimeInMinutes(currentTime);
      if (selectedTimeInMinutes > currentTimeInMinutes) {
        toast.error("Current time is maximum time");
      }
      setFormData((prev) => ({
        ...prev,
        time: {
          value:
            selectedTimeInMinutes > currentTimeInMinutes ? currentTime : value,
          warning: !value ? true : false,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: { value: value, warning: !value ? true : false },
      }));
    }
  };

  // validate the form on submit
  const validateForm = (event) => {
    event.preventDefault();
    let data = { ...formData };
    data = {
      ...data,
      firstName: { ...data.firstName, warning: !data.firstName.value },
      lastName: { ...data.lastName, warning: !data.lastName.value },
      phoneNumberCode: {
        ...data.phoneNumberCode,
        warning: !data.phoneNumberCode.value,
      },
      phoneNumber: { ...data.phoneNumber, warning: !data.phoneNumber.value },
      email: { ...data.email, warning: validateEmail(data.email.value) },
      date: { ...data.date, warning: !data.date.value },
      time: { ...data.time, warning: !data.time.value },
      summary: { ...data.summary, warning: !data.summary.value },
    };
    setFormData({ ...data });
    if (
      !data.firstName.warning &&
      !data.lastName.warning &&
      !data.email.warning &&
      !data.time.warning &&
      !data.date.warning &&
      !data.summary.warning
    ) {
      dispatch(setFormDataNearMiss(data));
      navigate("/near-miss-report-summary");
    }
  };

  useEffect(() => {
    const selectedDate = formData.date.value;
    const selectedTime = formData.time.value;
    if (!selectedDate) {
      setFormData((prev) => ({
        ...prev,
        date: { value: today, warning: false },
      }));
    }
    if (!selectedTime) {
      setFormData((prev) => ({
        ...prev,
        time: { value: currentTime, warning: false },
      }));
    }
  }, []);

  return (
    <Form className="d-flex flex-column flex-grow-1 quickonepage">
      <div className="flex-grow-1 incident-report-container d-flex flex-column row-gap-3">
        <div className="provideinformation">
          <h6 className="fw-bold mb-3 text-center">Confirm your details</h6>
          <Row className="row-gap-3 gx-3">
            <Col xs={6}>
              <Form.Group controlId="formBasicName">
                <Form.Label className="d-none"></Form.Label>
                <Form.Control
                  name={"firstName"}
                  value={formData.firstName.value}
                  type="text"
                  placeholder="First name"
                  onChange={onChange}
                />
                {formData.firstName.warning && (
                  <p className="text-danger mt-1 mb-0">Enter first name</p>
                )}
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group controlId="formBasic1Name">
                <Form.Label className="d-none"></Form.Label>
                <Form.Control
                  name={"lastName"}
                  value={formData.lastName.value}
                  type="text"
                  placeholder="Last name"
                  onChange={onChange}
                />
                {formData.lastName.warning && (
                  <p className="text-danger mt-1 mb-0">Enter last name</p>
                )}
              </Form.Group>
            </Col>
            <Form.Group className="col-12" controlId="formBasicBusinessName">
              <div className="phn_input">
                <div className="phone-input">
                  <PhoneInput
                    name="phoneNumberCode"
                    country={"gb"}
                    disableTyping={true}
                    inputProps={{
                      readOnly: true,
                    }}
                    value={formData.phoneNumberCode.value}
                    onChange={(value) =>
                      onChange({
                        target: {
                          name: "phoneNumberCode",
                          value: `+${value}`,
                        },
                      })
                    }
                  />
                </div>
                <Form.Control
                  onKeyPress={(e) => {
                    if (
                      e.key === "e" ||
                      e.key === "E" ||
                      isNaN(Number(e.key))
                    ) {
                      e.preventDefault();
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === " ") {
                      e.preventDefault();
                    }
                  }}
                  name="phoneNumber"
                  type="text"
                  pattern="[0-9]*"
                  value={onChangeToNumber(formData.phoneNumber.value)}
                  onChange={onChange}
                  placeholder="Number"
                />
              </div>
              {(formData.phoneNumberCode.warning ||
                formData.phoneNumber.warning) && (
                <Stack direction="horizontal" gap={2}>
                  {formData.phoneNumberCode.warning && (
                    <p className="text-danger mt-1 mb-0">Enter phone code</p>
                  )}
                  {formData.phoneNumber.warning && (
                    <p className="text-danger mt-1 mb-0">Enter phone number</p>
                  )}
                </Stack>
              )}
            </Form.Group>
            <Col xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Label className="d-none"></Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Email"
                  value={formData.email.value}
                  name={"email"}
                  onChange={onChange}
                />
                {formData.email.warning && (
                  <p className="text-danger mt-1 mb-0">Enter valid email</p>
                )}
              </Form.Group>
            </Col>
          </Row>
        </div>
        <hr className="my-1" />
        <div>
          <h6 className="fw-bold mb-3 text-center">
            Please provide a summary of near miss
          </h6>
          <Row className="row-gap-3 gx-3">
            <Col xs={6}>
              <Form.Group controlId="formBasicEmail">
                <Form.Control
                  name="date"
                  type="date"
                  value={formData.date.value}
                  onChange={onChange}
                  max={today}
                />
                {formData.date.warning && (
                  <p className="text-danger mt-1 mb-0">Enter date</p>
                )}
              </Form.Group>
            </Col>
            <Col xs={6}>
              <Form.Group controlId="formBasicEmail">
                <Form.Control
                  name="time"
                  type="time"
                  value={formData.time.value}
                  max={currentTime}
                  onChange={onChange}
                />
                {formData.time.warning && (
                  <p className="text-danger mt-1 mb-0">Enter time</p>
                )}
              </Form.Group>
            </Col>
            <Col xs={12}>
              <Form.Group controlId="formBasicEmail">
                <Form.Control
                  as="textarea"
                  placeholder="Brief Summary"
                  style={{ height: "150px" }}
                  value={formData.summary.value}
                  name={"summary"}
                  onChange={onChange}
                />
                {formData.summary.warning && (
                  <p className="text-danger mt-1 mb-0">Enter summary</p>
                )}
              </Form.Group>
            </Col>
          </Row>
        </div>
      </div>
      <div className="incident-report-form-footer-action">
        <NavLink
          className="nav-link"
          to={{
            pathname: "/standardwithquickreport",
          }}
        >
          <Button variant="dark fw-bold h-100 px-3" type="button">
            Cancel
          </Button>
        </NavLink>
        <div>
          <Button
            onClick={(e) => validateForm(e)}
            variant="primary"
            type="button"
            className="button_custom fw-bold text-black"
          >
            Continue
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default NearMissPageOne;
